export default __webpack_public_path__ + "static/media/left_arrow.ead21fbd.svg";